define(function (require) {
    "use strict";

    var _ = require('underscore');
    var AppConfig = require('config/application');
    var template = require('text!./templates/form.tpl').default;
    var Marionette = require('marionette');
    var Bb = require('backbone');

    require('components/phoneinput/phoneinput');

    var ModelData = Bb.Model.extend({
        defaults: {
            owner: null,
            whereSend: null,
            categorySection: null,
            category: null,
            phone: null,
            subject: null, // тема вопроса
            message: null,
            new_partner: 0
        },
        validate: function (atr) {
            var errorArray = [];

            if(atr.owner == '-1') {
                errorArray.push('owner');
            }
            if(!atr.whereSend){
                errorArray.push('whereSend');
            }
            if(!atr.categorySection){
                errorArray.push('categorySection');
            }
            if(!atr.category) {
                errorArray.push('category');
            }
            if(!atr.phone) {
                errorArray.push('phone');
            }
            if(!atr.subject) {
                errorArray.push('subject');
            }
            if(!atr.message) {
                errorArray.push('message');
            }

            if(errorArray.length > 0) {
                return errorArray;
            }
        },
        resetModel: function () {
            this.set(this.defaults);
        }
    });

    return Marionette.ItemView.extend({
        template: template,

        ui: {
            selectTypePerson: '.js-type-person',
            selectWhereToSend: '.js-where-send',
            selectCategorySection: '.js-category-section',
            selectCategory: '.js-category',
            inputPhone: '.js-phone',
            inputSubject: '.js-subject',
            textAreaBody: '.js-body',

            fileInput: '.js-upload-file',
            preloaderFile: '.lpt-intercom-label-file-loader-js',

            submitBtn: '.js-submit'
        },
        events: {
            'click @ui.submitBtn': 'onSubmit',
            'change @ui.selectCategorySection': 'onChangeSelectCategory'
        },
        initialize: function (categoryArray) {
            this.categoryArray = categoryArray;
            this.modelData = new ModelData();
        },
        serializeData: function(){
            
            var d = {
                new_partner : this.modelData.get('new_partner'),
                phone       : this.modelData.get('phone')
            };

            return d;
        },
        setPartnerFlag: function(partnerFlag){
            this.modelData.set({new_partner: partnerFlag});
            this.render();
        },
        onSubmit: function () {
            this.modelData.resetModel();
            this._hideError();
            
            this.modelData.set(this.getFormObj());
            if (!this.ui.inputPhone.phoneinput('isCompleted')) {
                this.ui.inputPhone.addClass('error');
                return;
            }

            if(this.modelData.isValid()) {
                this.setPhoneInStore(this.modelData.get('phone'));
                this.triggerMethod("submitForm", this.modelData.toJSON());
            } else {
                this._showError(this.modelData.validationError);
            }
        },
        onRender: function () {
            this.attachMask();
            this._setPhoneInForm();
            this._setLoadFileInput();

            this._addCategorySection();
        },
        onChangeSelectCategory: function () {
            var selectionId = this.ui.selectCategorySection.val();
            this._updateCurrentSubCategory(selectionId);
        },
        _addCategorySection: function () {
            var options = '';
            for (var i in this.categoryArray) {

                var item = this.categoryArray[i];
                options += '<option value="'+ item.id +'">' + item.name + '</option>';
            }

            this.ui.selectCategorySection.append(options);
        },
        _addSubCategory: function () {
            this.ui.selectCategory.empty();

            if(this.selectCategory.length > 1){
                this.ui.selectCategory.prepend('<option disabled selected value="-1">Подкатегория пуста</option>');
            }

            var options = '';
            for (var i in this.selectCategory){
                var item = this.selectCategory[i];
                options += '<option value="'+ item.id +'">' + item.name + '</option>';
            }

            this.ui.selectCategory.append(options);
        },
        _updateCurrentSubCategory: function (selectionId) {
            var id = parseInt(selectionId);

            for(var key in this.categoryArray){
                if( this.categoryArray[key].id === id){
                    this.selectCategory = this.categoryArray[key].subcats;
                    break;
                }
            }

             this._addSubCategory();
        },

        _setPhoneInForm: function () {
            var phone = this.getPhoneFromStore();
            this.ui.inputPhone.val(phone);
        },
        _setLoadFileInput: function () {
            require('dropzone');

            var that = this;
            this.ui.fileInput.dropzone({
                url: '//my.lptracker.ru/upload/upload.php',
                    data: {
                    menu: 'leads'
                },
                sending: function (file, xhr, formData) {
                    that.on('destroy', function() {
                        this.cancelUpload(file);
                    }, this);
                },
                complete: function(req){

                    var dropzone = this;
                    if(typeof req.xhr.responseText != 'undefined' && !that.isDestroyed){
                        var response = $.parseJSON( req.xhr.responseText );
                        if(response.status == 1){
                            var data = response.result.data;
                            if(typeof data != 'undefined'){
                                _.each(data, function(value) {
                                    value.shortSize = dropzone.filesize(value.size);
                                    value.id = ~~value.id;
                                });

                                var file =  data[0];
                                var fileUrl = typeof file.url ==='string' ? file.url : file.url.original;

                                that.appendUrlInComment(fileUrl);
                                that.ui.preloaderFile.hide();
                            }
                        } else {
                            app.message.error('ошибка загрузки');
                        }
                    }
                },
                totaluploadprogress: function(e) {
                    if(!that.isDestroyed) {
                        that.ui.preloaderFile.show();
                    }
                }
            });
        },

        attachMask: function () {
            this.ui.inputPhone.phoneinput();
        },
        getFormObj: function () {
            function getCurrentOption(ui){
                return ui.find('option').filter(':selected').val();
            }

            return {
                owner: getCurrentOption(this.ui.selectTypePerson),
                whereSend: this.ui.selectWhereToSend.val(),
                categorySection: this.ui.selectCategorySection.val(),
                category: this.ui.selectCategory.val(),
                phone: this.ui.inputPhone.val(),
                subject: this.ui.inputSubject.val(),
                message: this.ui.textAreaBody.val()
            };
        },
        appendUrlInComment: function (urlString) {
            if(!this.fileisLoad){
                app.message.success('загрузилось');
                this.fileisLoad = true;
            }

            var url = 'http:'+ urlString;
            var textAreaText = this.ui.textAreaBody.val();
            this.ui.textAreaBody.val(textAreaText += '\n ' + url);
        },

        errorClass: 'error',
        _showError: function (errorArray) {
            errorArray.forEach(eachError.bind(this));

            function eachError(errorInputName) {
                
                switch (errorInputName) {
                    case 'owner':
                        this.ui.selectTypePerson.addClass(this.errorClass);
                        break;
                    case 'whereSend':
                        this.ui.selectWhereToSend.addClass(this.errorClass);
                        break;
                    case 'categorySection':
                        this.ui.selectCategorySection.addClass(this.errorClass);
                        break;
                    case 'category':
                        this.ui.selectCategory.addClass(this.errorClass);
                        break;
                    case 'phone':
                        this.ui.inputPhone.addClass(this.errorClass);
                        break;
                    case 'subject':
                        this.ui.inputSubject.addClass(this.errorClass);
                        break;
                    case 'message':
                        this.ui.textAreaBody.addClass(this.errorClass);
                        break;
                }
            }
        },
        _hideError: function () {
            this.$el.find('.' + this.errorClass).removeClass(this.errorClass);
        },

        STORE_PHONE_KEY: 'lptIntercomPhone',
        setPhoneInStore: function (phone) {
            if (typeof(Storage) === 'undefined') { return }
            app.storage.write(this.STORE_PHONE_KEY, phone);
        },
        getPhoneFromStore: function () {
            if (typeof(Storage) === 'undefined') { return }
            return app.storage.read(this.STORE_PHONE_KEY);
        }
    })
});